export default "__VITE_ASSET__DLghbLNG__"